import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const About = () => {
    const advantages = [
        {
            title: 'Superior Quality',
            description: 'Utilizing the finest materials for exceptional durability.'
        },
        {
            title: 'Affordable Rates',
            description: 'Providing competitive pricing without compromising.'
        },
        {
            title: 'Extensive Experience',
            description: 'Decades of expertise in supplying top-notch materials.'
        },
        {
            title: 'Customer-Centric Approach',
            description: 'Focused on providing excellent customer service and support.'
        }
    ];

    return (
        <section id="about" className="py-20 lg:py-28 bg-card">
            <div className="section-container">
                <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                    {/* Images Grid */}
                    <div className="relative">
                        <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-4">
                                <div className="rounded-2xl overflow-hidden shadow-lg">
                                    <img 
                                        src="https://customer-assets.emergentagent.com/job_673bff6c-2308-4c32-b063-9be9a3a42c9a/artifacts/9qdnnei5_WhatsApp%20Image%202024-01-05%20at%203.08.27%20PM.jpeg" 
                                        alt="Construction Materials"
                                        className="w-full h-48 lg:h-64 object-cover hover:scale-105 transition-transform duration-500"
                                    />
                                </div>
                                <div className="rounded-2xl overflow-hidden shadow-lg">
                                    <img 
                                        src="https://customer-assets.emergentagent.com/job_673bff6c-2308-4c32-b063-9be9a3a42c9a/artifacts/o6xvrsxv_WhatsApp%20Image%202024-01-05%20at%203.08.28%20PM%20%281%29.jpeg" 
                                        alt="Sand Supply"
                                        className="w-full h-32 lg:h-40 object-cover hover:scale-105 transition-transform duration-500"
                                    />
                                </div>
                            </div>
                            <div className="pt-8">
                                <div className="rounded-2xl overflow-hidden shadow-lg h-full">
                                    <img 
                                        src="https://customer-assets.emergentagent.com/job_673bff6c-2308-4c32-b063-9be9a3a42c9a/artifacts/0r1od4pu_WhatsApp%20Image%202024-01-05%20at%203.08.28%20PM.jpeg" 
                                        alt="Cement Bags"
                                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                                    />
                                </div>
                            </div>
                        </div>
                        
                        {/* Decorative element */}
                        <div className="absolute -z-10 -bottom-8 -right-8 w-48 h-48 bg-primary/5 rounded-full blur-2xl"></div>
                    </div>

                    {/* Content */}
                    <div className="space-y-8">
                        <div>
                            <p className="text-primary font-medium text-sm uppercase tracking-wider mb-3">
                                Dhakad Enterprises
                            </p>
                            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground leading-tight mb-6">
                                Quality Construction Materials
                            </h2>
                            <p className="text-muted-foreground leading-relaxed">
                                Delivering premium bricks, cement, stone, and steel to support robust and long-lasting 
                                construction projects. Dependable Supply Chain Ensuring prompt and reliable delivery of 
                                high-quality construction materials to meet your building needs efficiently.
                            </p>
                        </div>

                        {/* Advantages List */}
                        <div className="space-y-2">
                            <h3 className="font-display font-semibold text-xl text-foreground mb-4">Our Advantages</h3>
                            <div className="space-y-4">
                                {advantages.map((item, index) => (
                                    <div 
                                        key={index}
                                        className="flex items-start gap-3 group"
                                    >
                                        <CheckCircle2 className="w-5 h-5 text-primary mt-0.5 shrink-0 group-hover:scale-110 transition-transform" />
                                        <div>
                                            <span className="font-semibold text-foreground">{item.title}:</span>
                                            <span className="text-muted-foreground ml-1">{item.description}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
